import React from 'react'
import { Divider } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { subscriptionData } from './subscription.data'
import { CustomTable, FormLabels } from 'src/components'
import { subcriptionColumns } from 'src/core/table-columns'
import styles from './SubscriptionDetailsPageContent.module.scss'
import UserSubscriptionList from './UserSubscriptionList/UserSubscriptionList'
import { userAuthenticatedState, userSubscriptionsSelector } from 'src/features'

const SubscriptionDetailsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const user = useAppSelector(userAuthenticatedState)
  const hasPremiumCalculator = user.groups.includes('prime calculator')
  const userSubcriptions = useAppSelector(userSubscriptionsSelector)
  const userSubscriptionsAreVisible = userSubcriptions.length > 0

  const tableProps = {
    pageSize: 10,
    hidePagination: true,
    columns: subcriptionColumns,
    rowClassName: 'fade-animation',
    dataSource: subscriptionData(t),
  }

  return <>
    {/* Header */}
    <FormLabels
      title={t('Subscription.Header')}
      subtitle={hasPremiumCalculator ? t('Subscription.Calculator') : ''}
    />

    {/* User Subscriptions */}
    {userSubscriptionsAreVisible && <>
      <Divider className={styles.divider} />
      <UserSubscriptionList subscriptions={userSubcriptions} />
    </>}

    {/* Table with all features */}
    <Divider />
    <CustomTable {...tableProps} />
  </>
}

export default SubscriptionDetailsPageContent
